import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import PaperDraggable from "../../../../../../../../../components/PaperDraggable";
import { useMemo, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { headCellsTitulosPagar, headCellsTitulosPagarCompensacao } from "../../../../../../MIContasPagar/PreFiltrosListagem/dataGridConfig";
import { TableDataGridRef, TableDataGridV2 } from "../../../../../../../../../components/TableDataGridV2";
import { IDataListaTitulosPagar } from "../../../../../../../../../types/api/financeiro/pesquisar-titulos-pagar";
import { enqueueSnackbar } from "notistack";
import SelectPublico from "../../../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import { IDataPublicos } from "../../../../../../../../../types/api/geral/pesquisar-publicos";

export default function DialogCadastrarCompensacao({
    open,
    selected,
    liquidarTerceiros,
    handleChangeSelected,
    handleClose
}: DialogCadastrarCompensacaoProps) {

    const { getValues } = useFormContext();
    const tableRef = useRef<TableDataGridRef<IDataListaTitulosPagar>>(null)

    const [publico, setPublico] = useState<IDataPublicos | null>(null);

    const containerRef = useRef<HTMLDivElement>(null);
    const primeiroTitulo = getValues("selecionar_titulos")[0];
    const pesquisaPublico = useMemo(() => {
        if (liquidarTerceiros && publico) {
            return {
                tipo_publico_contem: [publico.tipo_publico],
                codigo_publico_contem: [publico.codigo_publico]
            }
        }
        return {
                tipo_publico_contem: [primeiroTitulo.tipo_publico],
                codigo_publico_contem: [primeiroTitulo.codigo_publico]
            }
    }, [primeiroTitulo, liquidarTerceiros, publico]);
    const dataRecebimento = getValues('finalizacao.data_recebimento');
    const funcaoTroca = getValues('funcaoTroca');

    const handleSubmit = () => {
        const selecionados = tableRef.current?.getSelectedRows() || []
        if (selecionados.length === 0) {
            enqueueSnackbar(`Selecione pelo menos um título para compensar`, { variant: "warning" })
            return;
        }
        handleChangeSelected(selecionados)
        handleClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Selecione os títulos a pagar
            </DialogTitle>

            <DialogContent>
                {
                    liquidarTerceiros &&
                    <Grid container my={2}>
                        <SelectPublico
                            value={publico}
                            onChange={(data) => setPublico(data)}
                        />
                    </Grid>
                }
                <Box ref={containerRef}>
                    <TableDataGridV2
                        ref={tableRef}
                        enableSelection
                        columns={liquidarTerceiros ?  headCellsTitulosPagar : headCellsTitulosPagarCompensacao }
                        url="financeiro/contas-pagar/pesquisar-titulos-pagar"
                        queryKey="pesquisar-titulos-pagar-compensacao"
                        queryParams={{
                            ...pesquisaPublico,
                            data_pagamento_is_null: true,
                            saldo_fixo: true,
                            emissao_fixa: dataRecebimento.format('YYYY-MM-DD'),
                            funcao_troca: funcaoTroca
                        }}
                        pagination="server"
                        defaultSelectedFields={selected}
                        selectedFields={['id', 'saldo_principal', 'data_vencimento', 'data_emissao']}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogCadastrarCompensacaoProps {
    open: boolean;
    liquidarTerceiros: boolean;
    selected: IDataListaTitulosPagar[];
    handleChangeSelected: (arg: IDataListaTitulosPagar[]) => void;
    handleClose: () => void;
}
